import { createContext } from 'react';

const ExerciseDialogsContext = createContext({ header: {} });

export { ExerciseDialogsContext };
